<template>
  <div class="bar p-x-20 remove-margin">
    <div class="keterangan d-flex-between remove-margin">
      <div class="f-14 f-regular f-c-primary p-t-16 remove-margin">
        <label class="m-d-0"> Training Saya </label>
        <div class="f-18 f-bold remove-margin">
          <b> {{ riwayatTraining.length }} Training </b>
        </div>
      </div>
      <button
        class="btn btn-outline-primary remove-margin"
        @click="routeRiwayat"
      >
        Riwayat Training
      </button>
    </div>

    <div class="card-scroll-container">
      <div class="card-container">
        <template v-for="(riwayat, index) in riwayatTraining">
          <CardRiwayat
            :status="riwayat.status_training"
            :nama_program="riwayat.training_jenis.nama"
            :idtraining="riwayat.id"
            :timestart="
              riwayat.training_detail[0] != null
                ? riwayat.training_detail[0].jadwal_training_mulai
                : ''
            "
            :key="index"
          />
        </template>
      </div>
    </div>

    <div class="separator m-x-min m-d-20" />
    <div class="m-x-min">
      <div class="p-x-20">
        <div class="f-18 f-bold">
          <p>Program yang Tersedia</p>
        </div>

        <div class="f-0 f-regular f-c-primary p-y-5">
          <label class="m-d-0">
            Mulai pelajari aplikasi smartowner dengan memilih, program yang tersedia dibawah ini </label>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { popParams } from "vuelidate/lib/params";
import { mapGetters, mapActions } from "vuex";
import { moduleName } from "../store/state";
import CardRiwayat from "./CardRiwayat.vue";

export default {
  name: "MyTraining",
  data() {
    return {
      showMyTraining: true,
    };
  },
  components: {
    CardRiwayat,
  },
  props: {
    something: "",
    dataList: {
      type: Array,
      default: function () {
        return [];
      },
    },
  },

  computed: {
    ...mapGetters(moduleName, {
      riwayatTraining: "riwayatTraining",
    }),
  },
  methods: {
    ...mapActions({
      getRiwayatTraining: `${moduleName}/getRiwayatTraining`,
    }),

    routeRiwayat() {
      this.$router.push({ name: "training.riwayat" });
    },
  },
};
</script>

<style>
.trainingList .d-flex-between {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.trainingList .separator {
  width: unset;
  height: 15px;
}

.bg {
  background-color: #fff8e1;
  color: #6f7287;
  padding: 20px;
  display: flex;
  padding: 12px 20px;
  align-items: center;
  flex: 1 0 0;
}

.text-container {
  display: flex;
}

.trainingList .text-container .epayment-container {
  width: 121px;
}

.trainingList .text-container .reminder-container {
  width: 71px;
}

.trainingList .card {
  border-radius: 8px;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  margin: 15px 0px;
}

.card-scroll-container {
  overflow-x: auto;
  overflow-y: hidden;
  white-space: nowrap;
}
</style>
